import React from 'react'

class LazyImage extends React.Component {
  componentDidUpdate() {
    if (typeof document !== 'undefined') {
      if (typeof document.lazyLoadInstance !== 'undefined') {
        document.lazyLoadInstance.update()
      }
    }
  }

  // Just render the image with data-src
  render() {
    const { alt, src, srcset, sizes, width, height, className, style } = this.props
    return (
      <img
        alt={alt}
        className={className ? `${className} lazy` : 'lazy'}
        data-src={src}
        data-srcset={srcset}
        data-sizes={sizes}
        width={width}
        height={height}
        style={style}
      />
    )
  }
}

export default LazyImage
